<div *ngIf="grammar && flow" class="grammar-renderer">
    <div class="renderer-header" *ngIf="flow.title">
        <h3>{{ flow.title }}</h3>
        <p class="subtext">Configure search behavior dynamically from grammar definition.</p>
    </div>

    <section *ngFor="let section of flow.sections" class="flow-section">
        <header class="section-header">
            <h4 *ngIf="section.title">{{ section.title }}</h4>
        </header>

        <div class="section-grid">
            <ng-container *ngFor="let node of section.nodes">
                <div *ngIf="node.kind === 'select' && isVisible(node)" class="node-wrapper control-card">
                    <label class="node-label" *ngIf="node.label">
                        {{ node.label }}
                        <span *ngIf="node.required" class="required-indicator">*</span>
                    </label>
                    <div class="select-field">
                        <select
                            [formControl]="getFormControl(getControlKey(node))"
                            [disabled]="node.disabled"
                            (change)="onSelectChange(node, $event)">
                            <option value="">{{ node.placeholder || 'Select an option' }}</option>
                            <option *ngFor="let option of getNodeOptions(node)" [value]="option.value">
                                {{ option.label }}
                            </option>
                        </select>
                        <span class="material-icons select-icon" aria-hidden="true">arrow_drop_down</span>
                    </div>
                    <span class="hint" *ngIf="node.placeholder">{{ node.placeholder }}</span>
                </div>

                <div *ngIf="node.kind === 'text' && isVisible(node)" class="node-wrapper control-card">
                    <label class="node-label" *ngIf="node.label">
                        {{ node.label }}
                        <span *ngIf="node.required" class="required-indicator">*</span>
                    </label>
                    <input
                        type="text"
                        [formControl]="getFormControl(getControlKey(node))"
                        [placeholder]="node.placeholder || 'Enter value'"
                        [disabled]="node.disabled"
                        (input)="onInputChange(node, $event)" />
                    <span class="hint" *ngIf="node.placeholder">{{ node.placeholder }}</span>
                </div>

                <div *ngIf="node.kind === 'preview' && isVisible(node)" class="node-wrapper preview-wrapper preview-card">
                    <div class="preview-title" *ngIf="node.label">{{ node.label }}</div>
                    <div class="preview-box">{{ renderPreview(node.template, node.dependsOn) }}</div>
                </div>

                <div *ngIf="node.kind === 'group' && isVisible(node)" class="node-wrapper group-wrapper group-card">
                    <label *ngIf="node.label" class="group-label">{{ node.label }}</label>

                    <div class="group-grid">
                        <ng-container *ngFor="let childNode of node.nodes">
                            <div *ngIf="childNode.kind === 'select' && isVisible(childNode)" class="nested-node control-card">
                                <label class="node-label" *ngIf="childNode.label">
                                    {{ childNode.label }}
                                    <span *ngIf="childNode.required" class="required-indicator">*</span>
                                </label>
                                <div class="select-field">
                                    <select
                                        [formControl]="getFormControl(getControlKey(childNode))"
                                        [disabled]="childNode.disabled"
                                        (change)="onSelectChange(childNode, $event)">
                                        <option value="">{{ childNode.placeholder || 'Select an option' }}</option>
                                        <option *ngFor="let option of getNodeOptions(childNode)" [value]="option.value">
                                            {{ option.label }}
                                        </option>
                                    </select>
                                    <span class="material-icons select-icon" aria-hidden="true">arrow_drop_down</span>
                                </div>
                                <span class="hint" *ngIf="childNode.placeholder">{{ childNode.placeholder }}</span>
                            </div>

                            <div *ngIf="childNode.kind === 'text' && isVisible(childNode)" class="nested-node control-card">
                                <label class="node-label" *ngIf="childNode.label">
                                    {{ childNode.label }}
                                    <span *ngIf="childNode.required" class="required-indicator">*</span>
                                </label>
                                <input
                                    type="text"
                                    [formControl]="getFormControl(getControlKey(childNode))"
                                    [placeholder]="childNode.placeholder || 'Enter value'"
                                    [disabled]="childNode.disabled"
                                    (input)="onInputChange(childNode, $event)" />
                                <span class="hint" *ngIf="childNode.placeholder">{{ childNode.placeholder }}</span>
                            </div>

                            <div *ngIf="childNode.kind === 'preview' && isVisible(childNode)" class="nested-node preview-card">
                                <div class="preview-title" *ngIf="childNode.label">{{ childNode.label }}</div>
                                <div class="preview-box">{{ renderPreview(childNode.template, childNode.dependsOn) }}</div>
                            </div>

                            <div
                                *ngIf="childNode.kind === 'group' && isVisible(childNode)"
                                class="nested-node group-wrapper nested-group-card">
                                <label *ngIf="childNode.label" class="nested-group-label">{{ childNode.label }}</label>
                                <div class="nested-group-grid">
                                    <ng-container *ngFor="let grandChildNode of childNode.nodes">
                                        <div
                                            *ngIf="grandChildNode.kind === 'select' && isVisible(grandChildNode)"
                                            class="nested-node control-card">
                                            <label class="node-label" *ngIf="grandChildNode.label">{{ grandChildNode.label }}</label>
                                            <div class="select-field">
                                                <select
                                                    [formControl]="getFormControl(getControlKey(grandChildNode))"
                                                    [disabled]="grandChildNode.disabled"
                                                    (change)="onSelectChange(grandChildNode, $event)">
                                                    <option value="">{{ grandChildNode.placeholder || 'Select an option' }}</option>
                                                    <option *ngFor="let option of getNodeOptions(grandChildNode)" [value]="option.value">
                                                        {{ option.label }}
                                                    </option>
                                                </select>
                                                <span class="material-icons select-icon" aria-hidden="true">arrow_drop_down</span>
                                            </div>
                                            <span class="hint" *ngIf="grandChildNode.placeholder">{{ grandChildNode.placeholder }}</span>
                                        </div>

                                        <div
                                            *ngIf="grandChildNode.kind === 'text' && isVisible(grandChildNode)"
                                            class="nested-node control-card">
                                            <label class="node-label" *ngIf="grandChildNode.label">{{ grandChildNode.label }}</label>
                                            <input
                                                type="text"
                                                [formControl]="getFormControl(getControlKey(grandChildNode))"
                                                [placeholder]="grandChildNode.placeholder || 'Enter value'"
                                                [disabled]="grandChildNode.disabled"
                                                (input)="onInputChange(grandChildNode, $event)" />
                                            <span class="hint" *ngIf="grandChildNode.placeholder">{{ grandChildNode.placeholder }}</span>
                                        </div>

                                        <div
                                            *ngIf="grandChildNode.kind === 'preview' && isVisible(grandChildNode)"
                                            class="nested-node preview-card">
                                            <div class="preview-title" *ngIf="grandChildNode.label">{{ grandChildNode.label }}</div>
                                            <div class="preview-box">
                                                {{ renderPreview(grandChildNode.template, grandChildNode.dependsOn) }}
                                            </div>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </ng-container>
        </div>
    </section>
</div>

<div *ngIf="!grammar" class="empty-state">No grammar provided.</div>

<div *ngIf="grammar && !flow" class="empty-state">Flow "{{ flowId }}" not found in grammar.</div>
